import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
import { setupListeners } from '@reduxjs/toolkit/query'
import createSagaMiddleware from 'redux-saga'
import Sagas from './Sagas'
import storage from 'redux-persist/lib/storage'

import { rootReducer } from './Reducer'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'subscriptionForm',
    'subscriptionFormConfiguration',
    'formV2',
    'formConfigurationV2',
    'searchContacts',
    'usersManagement',
    'officesManagement',
    'assistanceProducts',
    'monConseillerPersoProducts',
    'carbonOffsets',
    'servicesStatus',
    'pageConfiguration',
    'clientCallbacks',
    'additionalProductsTools',
    'organizationsManagement',
    'suppliersManagement',
    'dashboardV2',
    'home',
    'contactsTools',
    'nettingUpdaterTools',
  ],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const sagaMiddleware = createSagaMiddleware()

export default preloadedState => {
  const store = configureStore({
    reducer: persistedReducer,
    middleware: [
      ...getDefaultMiddleware({
        serializableCheck: false,
      }),
      sagaMiddleware,
    ],
    preloadedState,
    devTools: !import.meta.env.PROD,
  })

  sagaMiddleware.run(Sagas)

  const persistor = persistStore(store)
  setupListeners(store.dispatch)

  return {
    store,
    persistor,
  }
}
